import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";

import { resourcesReports } from "../../../helpers/backend_helper";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import FormatDate from "../../../components/Common/FormatDate";
import FormatCurrency from "../../../components/Common/FormatCurrency";
import PageLoader from "../../../components/Common/PageLoader";
import PageEmptyData from "../../../components/Common/PageEmptyData";
import DetailModal from "./DetailModal";
import dayjs from "dayjs";

const today = dayjs();

const initModal = {
  show: false,
  date: "",
  company_id: "",
  company_name: "",
};

const initFilters = {
  date: dayjs().format("YYYY-MM"),
  with_resellers_summary: true,
};

const FacturacioAdminReport = () => {
  const [modal, setModal] = useState(initModal);
  const [pending, setPending] = useState(true);
  const [reportData, setReportData] = useState();
  const [filters, setFilters] = useState(initFilters);

  useEffect(() => {
    const config = {
      params: filters,
    };

    setPending(true);
    resourcesReports("show", config, `resellerReport`)
      .then((response) => {
        if (!response) return;

        setReportData(response);
      })
      .finally(() => {
        setPending(false);
      });
  }, [filters]);

  document.title = "Facturación|Reportes";

  if (pending) return <PageLoader />;

  if (!reportData) return <PageEmptyData />;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardHeader>
              <Breadcrumbs
                title={"Facturación"}
                breadcrumbItem={"Facturación"}
              />
            </CardHeader>
            <CardBody>
              <Row>
                <Col md={2} className="text-right pb-3">
                  <div className="form-label mb-0">
                    <label>Seleccionar periodo</label>
                    <input
                      className="form-control"
                      type="month"
                      id="start"
                      name="start"
                      min="2023-01"
                      max={today.format("YYYY-MM")}
                      value={filters.date}
                      onChange={({ target }) => {
                        const date = target.value;

                        if (!date) return;

                        setFilters((prev) => ({
                          ...prev,
                          date,
                        }));
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md={8}>
                          <span className="text-uppercase fw-light text-muted mb-3 lh-1 d-block text-truncate">
                            Periodo
                          </span>
                          <h4 className="fw-normal mb-3">
                            <FormatDate
                              format="MMM YYYY"
                              className="text-capitalize"
                              date={reportData.period}
                            />
                          </h4>
                        </Col>
                        <Col
                          md={4}
                          className="text-center d-flex align-items-center justify-content-center"
                        >
                          <i
                            className="fa fa-calendar text-primary"
                            style={{ fontSize: 20 }}
                          ></i>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={2}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md={10}>
                          <span className="text-uppercase fw-light text-muted mb-3 lh-1 d-block text-truncate">
                            Resellers
                          </span>
                          <h4 className="fw-normal mb-3">
                            {reportData.resellersSummary.length}
                          </h4>
                        </Col>
                        <Col
                          md={2}
                          className="text-center d-flex align-items-center justify-content-center"
                        >
                          <i
                            className="fa fa-store text-primary"
                            style={{ fontSize: 20 }}
                          ></i>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={2}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md={10}>
                          <span className="text-uppercase fw-light text-muted mb-3 lh-1 d-block text-truncate">
                            Rutas
                          </span>
                          <h4 className="fw-normal mb-3">{reportData.totalRoutes}</h4>
                        </Col>
                        <Col
                          md={2}
                          className="text-center d-flex align-items-center justify-content-center"
                        >
                          <i
                            className="fa fa-road text-primary"
                            style={{ fontSize: 20 }}
                          ></i>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={2}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md={10}>
                          <span className="text-uppercase fw-light text-muted mb-3 lh-1 d-block text-truncate">
                            Unidades activas
                          </span>
                          <h4 className="fw-normal mb-3">
                            {reportData.totalUnidadesActivas}
                          </h4>
                        </Col>
                        <Col
                          md={2}
                          className="text-center d-flex align-items-center justify-content-center"
                        >
                          <i
                            className="fa fa-bus text-primary"
                            style={{ fontSize: 20 }}
                          ></i>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md={10}>
                          <span className="text-uppercase fw-light text-muted mb-3 lh-1 d-block text-truncate">
                            Costos
                          </span>
                          <h4 className="fw-normal mb-3">
                            <FormatCurrency value={reportData.totalCosto} />
                          </h4>
                        </Col>
                        <Col
                          md={2}
                          className="text-center d-flex align-items-center justify-content-center"
                        >
                          <i
                            className="fa fa-money-bill text-primary"
                            style={{ fontSize: 20 }}
                          ></i>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <Row>
                <Col md={12}>
                  <h4 className="mb-0 font-size-18">Resumen de resellers</h4>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Row>
                <Col md={12}>
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">Nombre del reseller</th>
                        <th scope="col" className="text-center">
                          Unidades
                        </th>
                        <th scope="col" className="text-center">
                          Unidades activas
                        </th>
                        <th scope="col" className="text-end">
                          Costo
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.resellersSummary.map((reseller) => (
                        <tr key={reseller.name}>
                          <td scope="row">{reseller.name}</td>
                          <td className="text-center">
                            {reseller.totalUnidades}
                          </td>
                          <td className="text-center">
                            {reseller.totalUnidadesActivas}
                          </td>
                          <td className="text-end">
                            <FormatCurrency value={reseller.costo} />
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-primary btn-sm"
                              title="Detalle de Ruta"
                              onClick={() => {
                                setModal({
                                  show: true,
                                  date: filters.date,
                                  company_id: reseller.company_id,
                                  name: reseller.name,
                                });
                              }}
                            >
                              <i className="fa fa-eye"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td className="text-start fw-bold">Total</td>
                        <td className="text-center fw-bold">
                          {reportData.totalUnidades}
                        </td>
                        <td className="text-center fw-bold">
                          {reportData.totalUnidadesActivas}
                        </td>
                        <td className="text-end fw-bold">
                          <FormatCurrency value={reportData.totalCosto} />
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {modal.show && <DetailModal modal={modal} setModal={setModal} />}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FacturacioAdminReport;
